function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
import { debounce as u } from "./debounce.js";
function f(r) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  _typeof(e) != "object" && (e = {});
  var _e = e,
    _e$leading = _e.leading,
    i = _e$leading === void 0 ? !0 : _e$leading,
    _e$trailing = _e.trailing,
    n = _e$trailing === void 0 ? !0 : _e$trailing,
    a = _e.signal;
  return u(r, t, {
    leading: i,
    trailing: n,
    signal: a,
    maxWait: t
  });
}
export { f as throttle };